module.exports = __webpack_public_path__ + "img/share-arrow.b220ad4e.png";